let defaultEventParams: any = {};

type ItemName = "Contribution"

type ECommerceParams = {
    itemName: ItemName;
    co2Kgs: string;
    price: {
        currency: string;
        value: string | number;
    };
    transactionId?: string;
}

interface IDefaultEventParams {
    merchant_code: string;
    [key: string]: any;
}

export const setWidgetAnalyticEventParams = (eventParams: IDefaultEventParams) => {
    defaultEventParams = eventParams;
    if(window.gtag) {
        // list of supported session variables
        // is configured in Tag Manager Workspace
        window.gtag('set', { merchant_code: eventParams.merchant_code } )
    }
}

export const sendAnalyticsEvent = (name: string, eCommerceParams: ECommerceParams | null = null) => {
    let eventParams = { ...defaultEventParams };

    if (eCommerceParams) {
        if (eCommerceParams.transactionId) {
            eventParams['transaction_id'] = eCommerceParams.transactionId;
        }
        eventParams['co2_kgs'] = eCommerceParams.co2Kgs;
        eventParams['value'] = eCommerceParams.price.value;
        eventParams['currency'] = eCommerceParams.price.currency;
        eventParams['items'] = [{ 
            item_name: eCommerceParams.itemName,
            quantity: 1,
            price: eCommerceParams.price.value,
            co2_kgs: eCommerceParams.co2Kgs
        }];
    }
    if(window.gtag){
        window.gtag('event', name, eventParams);
    } else {
        const message = {
            type: "ANALYTICS_EVENT",
            payload: {name, parameters: eventParams}
        };
        window.parent.postMessage(message, '*');
    }
}

